import { gql } from '@apollo/client';

export const GET_COMENTARIO_ID = gql`
  {
    getComentarioId @client
  }
`;

export const GET_COMENTARIOS = gql`
  query getComentarios($paginate: getComentariosPaginate!) {
    getComentarios(paginate: $paginate) {
      comentarios {
        node {
          _id
          articulo {
            _id
          }
          autor
          correo
          contenido
          respuesta {
            autor
            respuesta
          }
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const GET_ARTICULO_COMENTARIOS = gql`
  query getArticuloComentarios($paginate: getArticuloComentariosPaginate!) {
    getArticuloComentarios(paginate: $paginate) {
      comentarios {
        node {
          _id
          articulo {
            _id
          }
          autor
          correo
          contenido
          respuesta {
            autor
            respuesta
            createdAt
          }
          createdAt
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`;

export const ADD_COMENTARIO = gql`
  mutation createComentario($input: CreateComentarioInput!) {
    createComentario(input: $input) {
      _id
      articulo {
        _id
      }
      autor
      correo
      contenido
      respuesta {
        autor
        respuesta
      }
      code
      success
      message
    }
  }
`;

export const REPLY_COMENTARIO = gql`
  mutation replyComentario($input: ReplyComentarioInput!) {
    replyComentario(input: $input) {
      _id
      articulo {
        _id
      }
      autor
      correo
      contenido
      respuesta {
        autor
        respuesta
        createdAt
      }
      code
      success
      message
    }
  }
`;
